var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m475.074219 0h-438.148438c-20.394531 0-36.925781 16.53125-36.925781 36.925781v438.148438c0 20.394531 16.53125 36.925781 36.925781 36.925781h236.574219v-198h-66.5v-77.5h66.5v-57.035156c0-66.140625 40.378906-102.140625 99.378906-102.140625 28.257813 0 52.542969 2.105469 59.621094 3.046875v69.128906h-40.683594c-32.101562 0-38.316406 15.253906-38.316406 37.640625v49.359375h76.75l-10 77.5h-66.75v198h121.574219c20.394531 0 36.925781-16.53125 36.925781-36.925781v-438.148438c0-20.394531-16.53125-36.925781-36.925781-36.925781zm0 0"}));
}

FacebookIcon.defaultProps = {"height":"512pt","viewBox":"0 0 512 512","width":"512pt"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
